import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Spinner } from 'reactstrap';
import { OrderNode } from '../../graphql/queries/orders';

export interface InvoiceListRow extends OrderNode {
  invoiceNumber: string;
}

const InvoiceId = ({ row }: { row: { original: InvoiceListRow } }) => {
  const order = row.original;
  return (
    <Link to={`/orders/${order.databaseId}`} className="text-dark fw-medium">
      {order.invoiceNumber}
    </Link>
  );
};

const OrderId = ({ row }: { row: { original: InvoiceListRow } }) => {
  const order = row.original;
  const label = `#${order.orderNumber ?? order.databaseId}`;
  return (
    <Link to={`/orders/${order.databaseId}`} className="text-dark fw-medium">
      {label}
    </Link>
  );
};

interface DownloadPdfProps {
  row: { original: InvoiceListRow };
  onPrint: (row: InvoiceListRow) => void;
  printing?: boolean;
}

const DownloadPdf = ({ row, onPrint, printing }: DownloadPdfProps) => {
  const order = row.original;

  return (
    <Button
      color="light"
      size="sm"
      className="btn-soft-light btn-sm w-xs waves-effect btn-label waves-light"
      disabled={printing}
      onClick={() => onPrint(order)}
    >
      {printing ? (
        <Spinner size="sm" className="label-icon" />
      ) : (
        <i className="bx bx-download label-icon"></i>
      )}{' '}
      Pdf
    </Button>
  );
};

export { InvoiceId, OrderId, DownloadPdf };
